export enum Endpoint {
  TOKEN = 'auth/jwt/token',
  REVOKE_TOKEN = 'auth/jwt/revoke',
  REFRESH_TOKEN = 'auth/jwt/refresh',
  FORGOT_PASSWORD = 'forgot-password',
  VALIDATE_ACCOUNT = 'validate-account',
  UNITS = 'units',
  LEADS = 'leads',
  APPLICATIONS = 'applications',
  UNIT_IMAGES = '/images/unit'
}
